import { Texture } from "../../resource/Texture";
import { Texture2DArray } from "../../resource/Texture2DArray";
import { TextureFormat } from "../../RenderEngine/RenderEnum/TextureFormat";
export class TextureArrayRegistry2D {
    static clear() {
        this._idToRecord.clear();
    }
    static register(source, array, layer) {
        const id = this._getTexId(source);
        if (id == null)
            return;
        this._idToRecord.set(id, { array, layer });
    }
    static unregister(source) {
        const id = this._getTexId(source);
        if (id == null)
            return;
        this._idToRecord.delete(id);
    }
    static resolve(source) {
        const id = this._getTexId(source);
        if (id == null)
            return null;
        return this._idToRecord.get(id) || null;
    }
    static allocateLayerAsTexture(width, height, format = TextureFormat.R8G8B8A8, capacity = 64, sRGB = false) {
        const key = `${width}x${height}_${format}_${sRGB ? 1 : 0}`;
        let group = this._groupKeyToArray.get(key);
        if (!group) {
            const array = new Texture2DArray(width, height, capacity, format, false, false, sRGB);
            group = { array, nextLayer: 0, capacity };
            this._groupKeyToArray.set(key, group);
        }
        if (group.nextLayer >= group.capacity)
            return null;
        const layer = group.nextLayer++;
        const virtualTex = new Texture(group.array);
        this.register(virtualTex, group.array, layer);
        const uploadSubPixels = (x, y, w, h, pixels, mipLevel = 0) => {
            group.array.setSubPixelsData(x, y, layer, w, h, 1, pixels, mipLevel, false, false, false);
        };
        return { texture: virtualTex, array: group.array, layer, uploadSubPixels };
    }
    static _getTexId(source) {
        if (!source)
            return null;
        if (source instanceof Texture) {
            const bmp = source.bitmap;
            return bmp._id;
        }
        if (typeof source.id === 'number')
            return source.id;
        if ((source === null || source === void 0 ? void 0 : source._texture) && typeof source._texture.id === 'number') {
            return source._texture.id;
        }
        return null;
    }
}
TextureArrayRegistry2D._idToRecord = new Map();
TextureArrayRegistry2D._groupKeyToArray = new Map();
